/**
 * LiveStream — the public player for anything broadcasting through LiveKit.
 *
 * Receive-only. Shows why there is no picture instead of a black rectangle:
 * a congregation, a TV audience and an event's delegates all get the same
 * honest states.
 */
import React from 'react';
import { Radio } from 'lucide-react';
import { useLiveKitViewer } from '@/lib/liveKit';

export const LiveStream = ({ scope, ident, title, testId = 'stream-livekit' }) => {
  const viewer = useLiveKitViewer(scope, ident, true);
  return (
    <div className="aspect-video w-full bg-black rounded-xl overflow-hidden shadow-2xl relative"
         data-testid={testId}>
      <video ref={viewer.attach} autoPlay playsInline controls
             className="w-full h-full object-contain" title={title} />
      {viewer.state !== 'playing' && (
        <div className="absolute inset-0 flex items-center justify-center bg-slate-900/90 p-6">
          <div className="text-center max-w-sm">
            <Radio className={`h-10 w-10 mx-auto mb-3 ${
              viewer.state === 'connecting' ? 'text-rose-500 animate-pulse' : 'text-slate-600'}`} />
            <p className="text-slate-200 text-base" data-testid={`${testId}-state`}>
              {viewer.state === 'connecting' && 'Connecting…'}
              {viewer.state === 'waiting' && 'Waiting for the picture…'}
              {viewer.state === 'offline' && 'The broadcast has ended.'}
              {viewer.state === 'failed' && 'Could not connect to the broadcast.'}
            </p>
            {viewer.message && viewer.state === 'failed' && (
              <p className="text-slate-500 text-sm mt-1.5">{viewer.message}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LiveStream;
